import { render, staticRenderFns } from "./loading4.vue?vue&type=template&id=4c09948a&scoped=true&"
import script from "./loading4.vue?vue&type=script&lang=js&"
export * from "./loading4.vue?vue&type=script&lang=js&"
import style0 from "./loading4.scss?vue&type=style&index=0&id=4c09948a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c09948a",
  null
  
)

export default component.exports